import { Component, useEffect, useState, useContext } from 'react';
import './cardProductsV2.css';

import * as $ from 'jquery';

import Button from '../buttons/buttons';
import Form from '../form/form';
import MyContext from '../../globalState/globalState'


function CardProductsV2({item, card, index, tipo , layout, img, destaque, log, planoPag}) {
  const contexto = useContext(MyContext);
  const[ready, setReady] = useState(false);
  let preco = 0.0;
  const [precoPor, setPrecoPor] = useState("");
  const [precoDe, setPrecoDe] = useState("");
  const [titulo, setTitulo] = useState('');
  const [texto, setTexto] = useState('');
  const [btn, setBtn] = useState('');
  const[isOpen, setIsOpen] = useState(false);
  const [cardStyle, setCardStyle] = useState('');
  const [bestProductLabel, setBestProductLabel] = useState(false)
  const [hiddenDesconto, setHiddenDesconto] = useState(false)


  useEffect(() =>{
    getProdutos();
  },[])

  const getProdutos = () => {
    if(item.length !== 0){
      // console.log(item)
      getPrice();
      setReady(true);
    }
  }
  const bestProduct = (produtoDestaque) => {
    if(produtoDestaque === 'S'){
      setCardStyle("card-best-seller");
      setBestProductLabel(true)
    }else{
      setCardStyle("pt-35");
      setBestProductLabel(false)
    }
  }
  const tooglePopup = () => {
    setIsOpen(!isOpen);
  }
  const reloadValues = (field, name, card, value) => {
    getPrice(name, value);
  }
  const getPrice = (name, value) => {
    if(name === undefined || value === undefined){
      if(item[0].produ_dmvl_precocomdesconto){
        setPrecoDe(parseFloat(item[0].produ_dmvl_precovenda).toFixed(2).toString().replace(".", ","));
        preco = parseFloat(item[0].produ_dmvl_precocomdesconto);
        setPrecoPor(parseFloat(preco).toFixed(2).toString().replace(".", ","));
        setHiddenDesconto(true)
      }else{
        preco = parseFloat(item[0].produ_dmvl_precovenda);
        setPrecoPor(parseFloat(preco).toFixed(2).toString().replace(".", ","));
        setHiddenDesconto(false)
      }
      setTitulo(item[0].rubri_vcds_comercial);
      setTexto(item[0].rubri_txds_conteudo);
      setBtn(item[0].rubri_inid_rubricaproduto);
      bestProduct(item[0].produ_dmsn_destaque);
    }else{
      if(item[value].produ_dmvl_precocomdesconto){
        setPrecoDe(parseFloat(item[value].produ_dmvl_precovenda).toFixed(2).toString().replace(".", ","));
        preco = parseFloat(item[value].produ_dmvl_precocomdesconto);
        setPrecoPor(parseFloat(preco).toFixed(2).toString().replace(".", ","));
        setHiddenDesconto(true)
      }else{
        preco = parseFloat(item[value].produ_dmvl_precovenda);
        setPrecoPor(parseFloat(preco).toFixed(2).toString().replace(".", ","));
        setHiddenDesconto(false)
      }
      setTitulo(item[value].rubri_vcds_comercial);
      setTexto(item[value].rubri_txds_conteudo);
      setBtn(item[value].rubri_inid_rubricaproduto);
      bestProduct(item[0].produ_dmsn_destaque);
    }
  };
  
    return (
      <div className={layout + " text-center"}>
        {isOpen && <Form HandleClose={tooglePopup} 
                  content={<div>
                      <h2>Texto</h2>
                      <p>Formulário</p>
                    </div>}
                    idCertificado = {btn} titulo={titulo} log={log} />}
        {ready?
          <div className={`Card-Products ${cardStyle} animated animatedFadeInUp fadeInUp`} id={card}>
            {bestProductLabel? 
                <div className='best-product-label'>
                  <span className='span-best-product-label'><i class="bi bi-star"></i> O mais comprado!</span>
                </div> 
              : <></>}
            <div className='img-card-produto'>
              <img src={img} alt={titulo} />
            </div>
            <h2 className='Card-Title-Products'>{titulo}</h2>
            <p className='Card-Text'>{texto}</p>
            <hr></hr>
            <select onChange={(value) => reloadValues(value, item[0].rubri_vcds_comercial, card, value.target.value)} id={item[0].rubri_vcds_comercial}>
              {item.map((response, index) => {
                return <option key={index} value={index}>{response.produ_inqt_diasvalidade/365} Ano(s)</option> /*response.rubri_inid_rubricaproduto*/
              })}
            </select>
            <p className='Card-price'>Escolha o tempo do certificado</p>
            {hiddenDesconto && contexto.mostraPrecoCheio === "S"?
            <>
              <p className='Card-Price old'>R$ {precoDe}</p>
              <p className='Card-Price new'>R$ {precoPor}</p>
            </>
            :
            <>
              <p className='Card-Price new only'>R$ {precoPor}</p>
              
            </>
            }
            <p className='Card-price'>{planoPag}</p>
            <div className='Card-Button'>
            <Button btnProduct click={tooglePopup} labelBtn='Comprar' function='tooglePopup' destaque={`${item[0].produ_dmsn_destaque === 'S'? 'btnProductDestaque' : ''}`}/>
            </div>
          </div>
        :null
        }
      </div>
    );
  }
  
  export default CardProductsV2;